import script from "./attribution.vue?vue&type=script&setup=true&lang=js"
export * from "./attribution.vue?vue&type=script&setup=true&lang=js"

import "./attribution.vue?vue&type=style&index=0&id=01a9c3ac&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a9c3ac"]])

export default __exports__